module.exports = __webpack_public_path__ + "static/media/gws.80126fb6.svg";